module.exports = __webpack_public_path__ + "img/green_026.48350d4b.png";